export const light_gray = '#828282';
export const defaultActiveColor = '#2a3b8f';
export const disabled_gray = 'gainsboro';
